function loginCarrotquest({ userId, hash }) {
    if (!window.dashly) {
        return
    }

    if (hash && userId) {
        dashly.auth(userId, hash)
    }
}

function setUserDataToCarrotquest(userData) {
    if (!window.dashly) {
        return
    }

    dashly.identify(userData)
}

function setTrackToCarrotquest(track) {
    if (!window.dashly) {
        return
    }

    dashly.track(track)
}

export {
    loginCarrotquest,
    setUserDataToCarrotquest,
    setTrackToCarrotquest,
}
